/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ArticleRouteImport } from './routes/article'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CustomerKundennummerRouteImport } from './routes/customer/$kundennummer'

const ArticleRoute = ArticleRouteImport.update({
  id: '/article',
  path: '/article',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerKundennummerRoute = CustomerKundennummerRouteImport.update({
  id: '/customer/$kundennummer',
  path: '/customer/$kundennummer',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/article': typeof ArticleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/article': typeof ArticleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/article': typeof ArticleRoute
  '/customer/$kundennummer': typeof CustomerKundennummerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/article' | '/customer/$kundennummer'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/article' | '/customer/$kundennummer'
  id: '__root__' | '/' | '/article' | '/customer/$kundennummer'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArticleRoute: typeof ArticleRoute
  CustomerKundennummerRoute: typeof CustomerKundennummerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/article': {
      id: '/article'
      path: '/article'
      fullPath: '/article'
      preLoaderRoute: typeof ArticleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/$kundennummer': {
      id: '/customer/$kundennummer'
      path: '/customer/$kundennummer'
      fullPath: '/customer/$kundennummer'
      preLoaderRoute: typeof CustomerKundennummerRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArticleRoute: ArticleRoute,
  CustomerKundennummerRoute: CustomerKundennummerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
